import { Modal, Checkbox, Button } from "antd";
import jsPDF from "jspdf";
import { useState, useRef, useEffect } from "react";
import moment from "moment";
import { ToWords } from "to-words";
import { BsDownload, BsEye } from "react-icons/bs";
import { getStateFromGST } from "./getStateFromGST";

const GeneratePerformanceInvoicePDF = ({ isOpen, onClose, order }) => {
  const [showPeriod, setShowPeriod] = useState(true);
  const [showRatePerMonth, setShowRatePerMonth] = useState(true);
  const [showZeroAmountInventories, setShowZeroAmountInventories] =
    useState(false);
  const [showItemAmount, setShowItemAmount] = useState(false);
  const [showLogo, setShowLogo] = useState(true);
  const [showSeparateProductionCharges, setShowSeparateProductionCharges] =
    useState(false);
  const [showHoardingWisePrintingMounting, setShowHoardingWisePrintingMounting] =
    useState(false);
  const [showPrintingMountingOnly, setShowPrintingMountingOnly] =
    useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const pdfPreviewRef = useRef(null);
  const [pdfUrl, setPdfUrl] = useState("");
  const invoiceData = order?.bdfId || {};

  // console.log("order", order);

  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: false,
      ordinal: false,
    },
  });

  const generatePDF = () => {
    const doc = new jsPDF("p", "mm", "a4");

    let startY = 70;
    const columnWidths = showRatePerMonth
      ? [10, 75, 23, 15, 21, 21, 35]
      : [10, 98, 0, 15, 21, 21, 35];

    const rowHeight = 8;
    let headers = [];
    doc.setFont("helvetica", "bold").setFontSize(10);

    const addHeader = () => {
      // Header Section
      doc.setFont("helvetica", "bold").setFontSize(14);
      doc.text("PROFORMA INVOICE", 80, 65, { maxWidth: 100 });

      // doc.setFontSize(8);
      // doc.text("(Original for Buyer)", 35, 25);

      doc.setFontSize(14).setFont("helvetica", "bold");
      doc.text("Yellow Spot OOH", 10, 30, { maxWidth: 100 });
      doc.setFont("helvetica", "normal").setFontSize(10);

      const headerAddress = `12th Block, 4th Floor, Magnet Corporate Park, Opp. Grand Cambay, Thaltej, Ahmedabad-380054.`;
      const headerAddressLines = doc.splitTextToSize(headerAddress, 100);
      doc.text(headerAddressLines, 10, 35);

      const headerAddressHeight = headerAddressLines.length * 5;

      let contentStartY = 30 + headerAddressHeight + 5;

      doc.setFont("helvetica", "bold");
      doc.text("Phone No.: 9033001770", 10, contentStartY);
      contentStartY += 5;
      doc.text(
        "GST No. : 24AADFY0077E1ZE, PAN No. : AADFY0077E",
        10,
        contentStartY
      );
      contentStartY += 5;
      doc.text("MSME No. : UDYAM-GJ-01-0215162", 10, contentStartY);
      doc.setFont("helvetica", "normal");

      if (showLogo) {
        doc.addImage("/images/pptSlide11.png", "PNG", 165, 20, 35, 35);
      }

      let addressLeftY = 70;
      const gstNumber = invoiceData?.parentCompanyId?.gstNumber || "NA";
      const panFromGst =
        gstNumber !== "NA" && gstNumber.length >= 15
          ? gstNumber.substring(2, 12)
          : "NA";

      // Get state information from GST number
      const stateCode = gstNumber !== "NA" ? gstNumber.substring(0, 2) : "NA";
      const stateName = getStateFromGST(gstNumber);
      const partyName =
        invoiceData?.billingPartyName ||
        invoiceData?.parentCompanyName ||
        "N/A";

      const addressLeftText = [
        "To,",
        partyName,
        invoiceData?.billingAddress || "N/A",
        `State : ${stateName}, Code : ${stateCode}`,
        `GST No. : ${gstNumber}`,
        `PAN No. : ${panFromGst}`,
      ];

      // const wrappedAddressLeftText = doc.splitTextToSize(addressLeftText, 90);
      // const lineHeight = 5;
      // const addressLeftHeight = wrappedAddressLeftText.length * lineHeight + 2;

      // wrappedAddressLeftText.forEach((line, index) => {
      //   if (
      //     index === 1 ||
      //     index === wrappedAddressLeftText.length - 1 ||
      //     index === wrappedAddressLeftText.length - 2
      //   ) {
      //     doc.setFont("helvetica", "bold");
      //   } else {
      //     doc.setFont("helvetica", "normal");
      //   }

      //   const currentYPosition = addressLeftY + index * lineHeight;

      //   doc.text(line, 15, currentYPosition + 5);
      // });

      const lineHeight = 5;

      // Check if the party name will fit on one line with current font size
      doc.setFont("helvetica", "bold").setFontSize(10);
      const maxWidth = 90; // Max width for the text in that cell
      let fontSize = 10; // Start with default font size
      let textWidth = doc.getTextWidth(partyName);

      // If the text is too wide, reduce the font size until it fits
      if (textWidth > maxWidth) {
        // Gradually reduce font size until text fits or reaches minimum size
        while (textWidth > maxWidth && fontSize > 6) {
          fontSize -= 0.5;
          doc.setFontSize(fontSize);
          textWidth = doc.getTextWidth(partyName);
        }
      }

      // Reset font for the rest of the process
      doc.setFont("helvetica", "normal").setFontSize(10);

      const wrappedAddressLeftText = [];
      for (let i = 0; i < addressLeftText.length; i++) {
        if (i === 1) {
          // This is the party name
          wrappedAddressLeftText.push(addressLeftText[i]);
        } else {
          // For other lines, wrap if needed
          const wrapped = doc.splitTextToSize(addressLeftText[i], 88);
          wrappedAddressLeftText.push(...wrapped);
        }
      }

      const addressLeftHeight = wrappedAddressLeftText.length * lineHeight + 2;

      wrappedAddressLeftText.forEach((line, index) => {
        // Determine which line corresponds to the party name
        const isPartyNameLine = line === partyName;

        if (
          isPartyNameLine ||
          index === wrappedAddressLeftText.length - 1 ||
          index === wrappedAddressLeftText.length - 2
        ) {
          doc.setFont("helvetica", "bold");

          // If this is the party name and we need a smaller font
          if (isPartyNameLine && fontSize < 10) {
            doc.setFontSize(fontSize);
          }
        } else {
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10); // Reset to default font size
        }

        const currentYPosition = addressLeftY + index * lineHeight;
        doc.text(line, 15, currentYPosition + 5);

        // Reset font size after party name
        if (isPartyNameLine && fontSize < 10) {
          doc.setFontSize(10);
        }
      });

      // const addressRightY = addressLeftY;
      // const addressRightText = [
      //   `PI No. : ${order?.stamp || "NA"}`,
      //   `Date : ${moment(order?.createdAt).format("DD-MM-YYYY")}`,
      //   `Brand Name : ${invoiceData?.brandId?.brandName || "NA"}`,
      //   `Place of Supply : Gujarat`,
      //   `Reverse Charge : N`,
      // ];
      // const addressRightHeight = addressRightText.length * 5 + 10;

      // const maxHeight = Math.max(addressLeftHeight, addressRightHeight);

      // doc.rect(10, addressLeftY, 95, maxHeight);

      // doc.rect(105, addressRightY, 95, maxHeight);

      // doc.setFont("helvetica", "bold");
      // addressRightText.forEach((line, index) => {
      //   doc.text(line, 110, addressRightY + 5 + index * 5);
      // });
      // doc.setFont("helvetica", "normal");

      const addressRightY = addressLeftY;

      // Extract brand label and value separately
      const brandLabel = "Brand Name : ";
      const brandValue = invoiceData?.brandId?.brandName?.toUpperCase() || "NA";

      const addressRightText = [
        `PI No. : ${order?.stamp || "NA"}`,
        `Date : ${moment(order?.createdAt).format("DD-MM-YYYY")}`,
        // We'll handle the brand name separately, but keep a placeholder
        "brand_name_placeholder",
        `Place of Supply : Gujarat`,
        `Reverse Charge : N`,
      ];
      const addressRightHeight = addressRightText.length * 5 + 10;

      const maxHeight = Math.max(addressLeftHeight, addressRightHeight);

      doc.rect(10, addressLeftY, 95, maxHeight);
      doc.rect(105, addressRightY, 95, maxHeight);

      // Render each line
      addressRightText.forEach((line, index) => {
        doc.setFont("helvetica", "bold");

        // Special handling for brand name line
        if (line === "brand_name_placeholder") {
          // First, render the label part with normal font size
          doc.setFontSize(10);
          doc.text(brandLabel, 110, addressRightY + 5 + index * 5);

          // Calculate the width of the label to position the value
          const labelWidth = doc.getTextWidth(brandLabel);

          // Check if the brand value will fit with standard font
          const maxRightValueWidth = 80 - labelWidth; // Max width for the value part
          let brandFontSize = 10; // Start with default font size

          doc.setFontSize(10);
          let brandValueWidth = doc.getTextWidth(brandValue);

          // If the value is too wide, reduce its font size until it fits
          if (brandValueWidth > maxRightValueWidth) {
            // Gradually reduce font size until text fits or reaches minimum size
            while (brandValueWidth > maxRightValueWidth && brandFontSize > 6) {
              brandFontSize -= 0.5;
              doc.setFontSize(brandFontSize);
              brandValueWidth = doc.getTextWidth(brandValue);
            }
          }

          // Now render the value part with possibly reduced font size
          doc.text(brandValue, 110 + labelWidth, addressRightY + 5 + index * 5);

          // Reset font size
          doc.setFontSize(10);
        } else {
          // Normal rendering for other lines
          doc.text(line, 110, addressRightY + 5 + index * 5);
        }
      });

      doc.setFont("helvetica", "normal").setFontSize(10);

      startY = addressLeftY + maxHeight;

      doc.rect(10, startY, 190, rowHeight);

      doc.line(10, startY, 10, startY + rowHeight);
      doc.line(20, startY, 20, startY + rowHeight);
      doc.line(
        210 - columnWidths[columnWidths.length - 1],
        startY,
        210 - columnWidths[columnWidths.length - 1],
        startY + rowHeight
      );
      doc.line(200, startY, 200, startY + rowHeight);

      headers = ["Sr", "Media/Location"];
      if (showRatePerMonth) {
        headers.push("Rate/Month");
      } else {
        headers.push("");
      }
      headers.push("Size");
      if (showPeriod) {
        headers.push("From Date", "To Date");
      } else {
        headers.push("", "");
      }
      headers.push("Amount");

      doc.setFont("helvetica", "bold");

      headers.forEach((header, i) => {
        if (!showRatePerMonth && i === 2) return;
        if (!showPeriod && (i === 4 || i === 5)) return;
        // Calculate position based on column widths
        const position =
          12 + columnWidths.slice(0, i).reduce((a, b) => a + b, 0);

        doc.text(header, position, startY + 5);
      });

      doc.setFont("helvetica", "normal");

      startY += rowHeight;
    };

    addHeader();

    const rows = [];

    rows.push([
      "",
      `Being the charges for Advertisement through display your ad on Outdoor Hoarding sites at`,
      "",
      "",
      "",
      "",
      "",
    ]);

    // rows.push(
    //   ...(invoiceData?.inventories?.map((inventory, index) => [
    //     `${index + 1}`,
    //     inventory?.invId?.locations?.name || "NA",
    //     new Intl.NumberFormat("en-IN", {
    //       minimumFractionDigits: 0,
    //       maximumFractionDigits: 0,
    //     }).format(inventory?.specialRatePerMonth || 0),
    //     `${inventory?.invId?.width} x ${inventory?.invId?.height}` || "NA",
    //     moment(inventory?.startDate).format("DD-MM-YYYY"),
    //     moment(inventory?.endDate).format("DD-MM-YYYY"),
    //     new Intl.NumberFormat("en-IN", {
    //       minimumFractionDigits: 2,
    //       maximumFractionDigits: 2,
    //     }).format(inventory?.specialRate || 0),
    //   ]) || [])
    // );

    // // ✅ Sum up printingCharge and mountingCharge from each inventory
    // const totalProductionCharges = invoiceData?.inventories?.reduce(
    //   (totals, inv) => {
    //     return {
    //       printingCharge:
    //         totals.printingCharge + (Number(inv?.printingCharge) || 0),
    //       mountingCharge:
    //         totals.mountingCharge + (Number(inv?.mountingCharge) || 0),
    //     };
    //   },
    //   { printingCharge: 0, mountingCharge: 0 }
    // ) || { printingCharge: 0, mountingCharge: 0 };

    // const totalProductionCost =
    //   totalProductionCharges.printingCharge +
    //   totalProductionCharges.mountingCharge;

    // rows.push([
    //   `${rows.length}`,
    //   "Printing & Mounting Charges",
    //   "",
    //   "",
    //   "",
    //   "",
    //   new Intl.NumberFormat("en-IN", {
    //     minimumFractionDigits: 2,
    //     maximumFractionDigits: 2,
    //   }).format(Number(totalProductionCost) || 0),
    // ]);

    // rows.push(
    //   ...Array(10).fill([
    //     "",
    //     "test",
    //     "test test test test test test test test test test test test test",
    //     "9",
    //     "9",
    //     "9",
    //     "9",
    //     "9",
    //   ])
    // );

    const invsAll = invoiceData?.inventories || [];
    const suffixAll = invoiceData?.suffixInventories || [];

    const lineSpecialTotal =
      (invsAll.reduce(
        (sum, inventory) => sum + (Number(inventory?.specialRate) || 0),
        0
      ) || 0) +
      (suffixAll.reduce(
        (sum, inventory) => sum + (Number(inventory?.specialRate) || 0),
        0
      ) || 0);

    const totalProductionCharges = invsAll.reduce(
      (totals, inv) => ({
        printingCharge:
          totals.printingCharge + (Number(inv?.printingCharge) || 0),
        mountingCharge:
          totals.mountingCharge + (Number(inv?.mountingCharge) || 0),
      }),
      { printingCharge: 0, mountingCharge: 0 }
    ) || { printingCharge: 0, mountingCharge: 0 };

    const sumLineP = totalProductionCharges.printingCharge;
    const sumLineM = totalProductionCharges.mountingCharge;
    const invLevelP = Number(invoiceData?.printingCharge) || 0;
    const invLevelM = Number(invoiceData?.mountingCharge) || 0;
    const useInvoiceLevelSplit =
      (invLevelP > 0 || invLevelM > 0) && sumLineP === 0 && sumLineM === 0;

    const totalProductionComputed = useInvoiceLevelSplit
      ? invLevelP + invLevelM
      : sumLineP + sumLineM;

    const effectiveLineSpecial = showPrintingMountingOnly ? 0 : lineSpecialTotal;
    const total = effectiveLineSpecial + totalProductionComputed;

    const moneyFmt = new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const rpmFmt = new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    const totalFormattedDisplay = moneyFmt.format(total);

    const passesZeroInv = (inv) =>
      showZeroAmountInventories || Number(inv?.specialRate) !== 0;
    const passesZeroSuffix = (s) =>
      showZeroAmountInventories || Number(s?.specialRate) !== 0;

    const printingMountingForLine = (inv) => {
      if (useInvoiceLevelSplit) {
        const w =
          lineSpecialTotal > 0
            ? (Number(inv?.specialRate) || 0) / lineSpecialTotal
            : invsAll.length > 0
              ? 1 / invsAll.length
              : 1;
        return { p: invLevelP * w, m: invLevelM * w };
      }
      return {
        p: Number(inv?.printingCharge) || 0,
        m: Number(inv?.mountingCharge) || 0,
      };
    };

    const bdfDateStr = invoiceData?.bdfDate
      ? moment(invoiceData.bdfDate).format("DD-MM-YYYY")
      : "";
    const isFromSubPi = Boolean(
      order?.isFromSub ?? invoiceData?.isFromSub
    );
    const productionFromTo =
      showPeriod && isFromSubPi ? bdfDateStr : "";

    const aggPrintForRows = useInvoiceLevelSplit ? invLevelP : sumLineP;
    const aggMountForRows = useInvoiceLevelSplit ? invLevelM : sumLineM;

    if (showHoardingWisePrintingMounting) {
      const billedList = invsAll.filter((inv) => {
        if (showZeroAmountInventories) return true;
        const { p, m } = printingMountingForLine(inv);
        return (
          Number(inv?.specialRate) !== 0 || p !== 0 || m !== 0
        );
      });
      let srNo = 0;
      billedList.forEach((inventory) => {
        const { p, m } = printingMountingForLine(inventory);
        const loc = inventory?.invId?.locations?.name || "NA";
        const sizeStr =
          `${inventory?.invId?.width} x ${inventory?.invId?.height}` || "NA";
        const fd = moment(inventory?.startDate).format("DD-MM-YYYY");
        const td = moment(inventory?.endDate).format("DD-MM-YYYY");
        srNo += 1;
        rows.push([
          `${srNo}`,
          `${loc} - Printing Charge`,
          "",
          sizeStr,
          fd,
          td,
          showItemAmount && srNo === 1
            ? totalFormattedDisplay
            : showItemAmount
              ? ""
              : moneyFmt.format(p),
        ]);
        srNo += 1;
        rows.push([
          `${srNo}`,
          `${loc} - Mounting Charge`,
          "",
          sizeStr,
          fd,
          td,
          showItemAmount ? "" : moneyFmt.format(m),
        ]);
      });
    } else {
      if (!showPrintingMountingOnly) {
        const forRows = invsAll.filter(passesZeroInv);
        forRows.forEach((inventory, index) => {
          rows.push([
            `${index + 1}`,
            inventory?.invId?.locations?.name || "NA",
            showRatePerMonth
              ? rpmFmt.format(inventory?.specialRatePerMonth || 0)
              : "",
            `${inventory?.invId?.width} x ${inventory?.invId?.height}` || "NA",
            moment(inventory?.startDate).format("DD-MM-YYYY"),
            moment(inventory?.endDate).format("DD-MM-YYYY"),
            showItemAmount && index === 0
              ? totalFormattedDisplay
              : showItemAmount
                ? ""
                : moneyFmt.format(Number(inventory?.specialRate) || 0),
          ]);
        });
      }

      const billedInvsForCount = invsAll.filter(passesZeroInv);
      const effectiveBilledInvsRowCount = showPrintingMountingOnly
        ? 0
        : billedInvsForCount.length;

      let suffixInventoriesCountForRows = 0;
      if (!showPrintingMountingOnly && suffixAll.length > 0) {
        const suffixForRows = suffixAll.filter(passesZeroSuffix);
        suffixInventoriesCountForRows = suffixForRows.length;
        suffixForRows.forEach((suffixInv, index) => {
          rows.push([
            `${effectiveBilledInvsRowCount + index + 1}`,
            suffixInv?.suffixInfo || "NA",
            "",
            "",
            moment(suffixInv?.startDate).format("DD-MM-YYYY"),
            moment(suffixInv?.endDate).format("DD-MM-YYYY"),
            showItemAmount &&
            effectiveBilledInvsRowCount === 0 &&
            index === 0
              ? totalFormattedDisplay
              : showItemAmount
                ? ""
                : moneyFmt.format(Number(suffixInv?.specialRate) || 0),
          ]);
        });
      }

      const nextSerialNumber = showPrintingMountingOnly
        ? 1
        : effectiveBilledInvsRowCount + suffixInventoriesCountForRows + 1;

      if (!showHoardingWisePrintingMounting && showSeparateProductionCharges) {
        if (aggPrintForRows > 0) {
          rows.push([
            `${nextSerialNumber}`,
            "Printing Charges",
            "",
            "",
            productionFromTo,
            productionFromTo,
            showItemAmount ? "" : moneyFmt.format(aggPrintForRows),
          ]);
        }
        if (aggMountForRows > 0) {
          rows.push([
            `${nextSerialNumber + (aggPrintForRows > 0 ? 1 : 0)}`,
            "Mounting Charges",
            "",
            "",
            productionFromTo,
            productionFromTo,
            showItemAmount ? "" : moneyFmt.format(aggMountForRows),
          ]);
        }
      } else if (!showHoardingWisePrintingMounting) {
        const combined = aggPrintForRows + aggMountForRows;
        if (combined > 0) {
          rows.push([
            `${nextSerialNumber}`,
            "Printing & Mounting Charges",
            "",
            "",
            productionFromTo,
            productionFromTo,
            showItemAmount ? "" : moneyFmt.format(combined),
          ]);
        }
      }
    }

    if (rows.length <= 4) {
      rows.push(...Array(2).fill(["", "", "", "", "", "", ""]));
    }

    // const totalSpecialRate = invoiceData?.inventories?.reduce(
    //   (sum, inventory) => sum + (inventory?.specialRate || 0),
    //   0
    // );

    // const total = totalSpecialRate + totalProductionCost;
    // // const total = totalSpecialRate;

    // const totalFormattedDisplay = new Intl.NumberFormat("en-IN", {
    //   minimumFractionDigits: 2,
    //   maximumFractionDigits: 2,
    // }).format(total);

    const totalFormatted = (Number(total) || 0).toFixed(2);

    const totalAmount = parseFloat(totalFormatted);

    const gstNumber = invoiceData?.parentCompanyId?.gstNumber || "NA";

    // Determine tax rates based on GST number prefix
    let sgstRate = 0;
    let cgstRate = 0;
    let igstRate = 0;

    // Check if GST number starts with "24" (Gujarat)
    if (gstNumber !== "NA" && gstNumber.substring(0, 2) === "24") {
      // If GST starts with 24 (Gujarat), apply CGST and SGST
      sgstRate = 9;
      cgstRate = 9;
      igstRate = 0;
    } else {
      // For all other states, apply IGST
      sgstRate = 0;
      cgstRate = 0;
      igstRate = 18;
    }

    const sgstAmount = (totalAmount * sgstRate) / 100;
    const cgstAmount = (totalAmount * cgstRate) / 100;
    const igstAmount = (totalAmount * igstRate) / 100;
    // const agencyCommAmount =
    //   (totalAmount * (invoiceData?.agencyCommission || 0)) / 100;
    // const municipalTaxAmount =
    //   (totalAmount * (invoiceData?.municipalTax || 0)) / 100;
    // const otherTaxAmount = (totalAmount * (invoiceData?.otherTaxes || 0)) / 100;
    // const roundTaxAmount = (totalAmount * (order?.round || 0)) / 100;

    const formatter = moneyFmt;

    // Note: Keep the original values for calculation purposes
    const sgstAmountValue = parseFloat((Number(sgstAmount) || 0).toFixed(2));
    const cgstAmountValue = parseFloat((Number(cgstAmount) || 0).toFixed(2));
    const igstAmountValue = parseFloat((Number(igstAmount) || 0).toFixed(2));
    // const agencyCommAmountFormatted = (Number(agencyCommAmount) || 0).toFixed(
    //   2
    // );
    // Calculate the sum before rounding
    const sumBeforeRounding =
      totalAmount + sgstAmountValue + cgstAmountValue + igstAmountValue;

    // Get the desired grand total from invoiceData, or use the sum if not specified
    // Apply consistent rounding in both cases
    const desiredGrandTotal = Math.round(sumBeforeRounding); // Round the calculated sum

    // Calculate the rounding adjustment
    const roundTaxAmount = desiredGrandTotal - sumBeforeRounding;
    const roundAmountValue = parseFloat(
      (Number(roundTaxAmount) || 0).toFixed(2)
    );

    // Format all values for display
    const sgstAmountFormatted = formatter.format(sgstAmountValue);
    const cgstAmountFormatted = formatter.format(cgstAmountValue);
    const igstAmountFormatted = formatter.format(igstAmountValue);
    const roundAmountFormatted = formatter.format(roundAmountValue);

    doc.setFontSize(9);

    let newSectionY;
    let newSectionHeight;

    const maxRowsPerPage = 9;
    let rowCount = 0;

    rows.forEach((row, rowIndex) => {
      if (rowCount >= maxRowsPerPage) {
        addSummarySection(false);
        addFooter();

        doc.addPage();
        addHeader();
        startY = startY || 70;
        rowCount = 0;
      }

      let currentX = 10;

      let rowTotalHeight = rowHeight;

      row.forEach((text, index) => {
        if (rowIndex === 0) {
          const staticTextWidth = 150;

          const wrappedText =
            doc.getTextWidth(text) > staticTextWidth
              ? doc.splitTextToSize(text, staticTextWidth)
              : [text];

          rowTotalHeight = Math.max(rowTotalHeight, wrappedText.length * 5);
          const textY =
            startY + rowTotalHeight / 2 - (wrappedText.length * 5) / 2 + 3;

          wrappedText.forEach((line, lineIndex) => {
            doc.text(line, currentX + 2, textY + lineIndex * 5 + 2);
          });

          currentX += columnWidths[index];
          return;
        }

        if (!showPeriod && (index === 4 || index === 5)) {
          currentX += columnWidths[index];
          return;
        }

        if (!showRatePerMonth && index === 2) {
          currentX += columnWidths[index];
          return;
        }

        const wrappedText = doc.splitTextToSize(text, columnWidths[index] - 3);
        rowTotalHeight = Math.max(rowTotalHeight, wrappedText.length * 5);

        const textY =
          startY + rowTotalHeight / 2 - (wrappedText.length * 5) / 2 + 3;

        wrappedText.forEach((line, lineIndex) => {
          doc.text(line, currentX + 2, textY + lineIndex * 5 + 2);
        });

        currentX += columnWidths[index];
      });

      doc.line(
        10 + columnWidths[0],
        startY,
        10 + columnWidths[0],
        startY + rowTotalHeight + 2
      );

      doc.line(
        currentX - columnWidths[columnWidths.length - 1],
        startY,
        currentX - columnWidths[columnWidths.length - 1],
        startY + rowTotalHeight + 2
      );

      doc.line(200, startY, 200, startY + rowTotalHeight + 2);

      doc.line(10, startY, 10, startY + rowTotalHeight + 2);

      startY += rowTotalHeight + 2;
      rowCount++;
    });

    doc.setFontSize(10);

    doc.line(10, startY, 200, startY);

    addSummarySection(true);

    function addSummarySection(isLastPage = false) {
      const firstSectionY = startY;
      const firstSectionHeight = isLastPage ? 28 : 0;
      doc.rect(10, firstSectionY, 95, firstSectionHeight);

      if (isLastPage) {
        doc.setFont("helvetica", "bold");
        // doc.text("PAN No. : AADFY0077E", 15, firstSectionY + 10);
        doc.text("GST Category :  Advertising Agency", 15, firstSectionY + 10);
        doc.text("HSN/SAC : 998361", 15, firstSectionY + 15);
        doc.setFont("helvetica", "normal");
      }

      const secondSectionY = firstSectionY;

      const maxHeight2 = firstSectionHeight;

      const secondSectionX = 105;
      const thirdSectionX = 175;
      doc.rect(secondSectionX, secondSectionY, 70, maxHeight2);
      doc.rect(thirdSectionX, secondSectionY, 25, maxHeight2);

      if (isLastPage) {
        let currentY = secondSectionY + 5;
        doc.text("Total", secondSectionX + 5, currentY);
        doc.text(totalFormattedDisplay, thirdSectionX + 2, currentY);
        currentY += 5;

        // Display SGST and CGST only if applicable (GST starts with 24)
        if (sgstRate > 0) {
          doc.text(`SGST : ${sgstRate} %`, secondSectionX + 5, currentY);
          doc.text(sgstAmountFormatted, thirdSectionX + 2, currentY);
          currentY += 5;

          doc.text(`CGST : ${cgstRate} %`, secondSectionX + 5, currentY);
          doc.text(cgstAmountFormatted, thirdSectionX + 2, currentY);
          currentY += 5;
        }

        // Display IGST only if applicable (GST doesn't start with 24)
        if (igstRate > 0) {
          doc.text(`IGST : ${igstRate} %`, secondSectionX + 5, currentY);
          doc.text(igstAmountFormatted, thirdSectionX + 2, currentY);
          currentY += 5;
        }

        if (roundAmountFormatted !== "0.00") {
          doc.text(`Round off`, secondSectionX + 5, currentY);
          doc.text(roundAmountFormatted, thirdSectionX + 2, currentY);
        }
      }

      // if (isLastPage) {
      //   doc.text(totalFormattedDisplay, thirdSectionX + 2, secondSectionY + 5);
      //   doc.text(sgstAmountFormatted, thirdSectionX + 2, secondSectionY + 10);
      //   doc.text(cgstAmountFormatted, thirdSectionX + 2, secondSectionY + 15);
      //   doc.text(igstAmountFormatted, thirdSectionX + 2, secondSectionY + 20);
      //   doc.text(roundAmountFormatted, thirdSectionX + 2, secondSectionY + 25);
      // }

      if (isLastPage) {
        doc.line(
          secondSectionX,
          secondSectionY + 21.5,
          secondSectionX + 70,
          secondSectionY + 21.5
        );
        doc.line(
          thirdSectionX,
          secondSectionY + 21.5,
          thirdSectionX + 25,
          secondSectionY + 21.5
        );
      }

      // else {
      //   doc.line(
      //     secondSectionX,
      //     secondSectionY + 22,
      //     secondSectionX + 70,
      //     secondSectionY + 22
      //   );
      //   doc.line(
      //     thirdSectionX,
      //     secondSectionY + 22,
      //     thirdSectionX + 25,
      //     secondSectionY + 22
      //   );
      // }

      if (isLastPage) {
        const grandTotal = desiredGrandTotal;
        const formattedGrandTotal = formatter.format(grandTotal);

        doc.setFont("helvetica", "bold");
        doc.text("Grand Total", secondSectionX + 5, secondSectionY + 26);
        doc.text(formattedGrandTotal, thirdSectionX + 2, secondSectionY + 26);
        doc.setFont("helvetica", "normal");

        const grandTotalInWords = toWords.convert(grandTotal);
        const formattedGrandTotalInWords = grandTotalInWords
          .toLowerCase()
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

        newSectionY = secondSectionY + maxHeight2;
        newSectionHeight = 10;

        doc.rect(10, newSectionY, 190, newSectionHeight);

        doc.setFont("helvetica", "bold");
        doc.text("Rupees :-", 15, newSectionY + 7);
        doc.setFont("helvetica", "normal");
        doc.text(formattedGrandTotalInWords + " Only", 35, newSectionY + 7);

        doc.line(
          10,
          newSectionY + newSectionHeight,
          200,
          newSectionY + newSectionHeight
        );
      } else {
        // Prevent undefined errors
        newSectionY = secondSectionY + maxHeight2;
        newSectionHeight = 0;
      }
    }

    function addFooter() {
      const finalSectionY = newSectionY + newSectionHeight;

      doc.setFont("helvetica", "bold").setFontSize(10);
      doc.text("Terms & Conditions:", 15, finalSectionY + 5);

      const termsText = [
        "1. Cheque & NEFT/RTGS Should be in favour of 'Yellow Spot OOH'.",
        "2. Please do not Deduct TDS On GST.",
        "3. Payment Immediately after issuing this bill.",
        "4. Interest at 18% per annum will be charged on overdue accounts from the date of this bill.",
        "5. Subject to Ahmedabad Jurisdiction.",
        "6. Once ordered should not be cancelled.",
      ];

      doc.setFont("helvetica", "normal").setFontSize(8);
      const lineSpacing = 2.8;
      const pointSpacing = 1;

      let currentY = finalSectionY + 10;
      termsText.forEach((text, index) => {
        const wrappedText = doc.splitTextToSize(text, 100);

        wrappedText.forEach((line, lineIndex) => {
          doc.text(line, 15, currentY);
          currentY += lineSpacing;
        });

        currentY += pointSpacing;
      });

      const bankDetailsY = currentY + 5;
      doc
        .setFont("helvetica", "bold")
        .text("BANK DETAILS : AXIS BANK LTD.", 15, bankDetailsY);
      doc
        .setFont("helvetica", "bold")
        .text(
          "A/C NO. 922020030481942, IFSC CODE: UTIB0002998",
          15,
          bankDetailsY + 5
        );

      const leftSectionHeight = bankDetailsY - finalSectionY + 10;

      doc.rect(10, finalSectionY, 115, leftSectionHeight);

      doc.rect(125, finalSectionY, 75, leftSectionHeight);
      doc
        .setFont("helvetica", "bold")
        .text("For, Yellow Spot OOH", 150, finalSectionY + 8);
      doc
        .setFont("helvetica", "bold")
        .text("[Authorised Signatory]", 150, bankDetailsY + 5);
      doc.addImage(
        "/images/yellowspotStamp.png",
        "PNG",
        150,
        finalSectionY + 10,
        30,
        30
      );
    }

    addFooter();

    return doc;
  };

  const handleGeneratePDF = () => {
    const doc = generatePDF();

    // Get the party name from invoice data for the filename
    const partyName =
      invoiceData?.billingPartyName ||
      invoiceData?.parentCompanyName ||
      "Invoice";

    const filename = `${partyName}_PI.pdf`;
    doc.save(filename);
  };

  const handlePreview = () => {
    const doc = generatePDF();
    const pdfBlob = doc.output("blob");

    if (pdfBlob) {
      setPdfUrl((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return URL.createObjectURL(pdfBlob);
      });
      setIsPreviewOpen(true);
    } else {
      console.error("Failed to generate PDF Blob.");
    }
  };

  useEffect(() => {
    if (isPreviewOpen && pdfUrl && pdfPreviewRef.current) {
      pdfPreviewRef.current.src = pdfUrl;
    }
  }, [isPreviewOpen, pdfUrl]);

  const handleClose = () => {
    setShowPeriod(true);
    setShowRatePerMonth(true);
    setShowZeroAmountInventories(true);
    setShowItemAmount(false);
    setShowLogo(true);
    setShowSeparateProductionCharges(false);
    setShowHoardingWisePrintingMounting(false);
    setShowPrintingMountingOnly(false);
    onClose();
  };

  const closePreviewModal = () => {
    setIsPreviewOpen(false);
    setPdfUrl((prev) => {
      if (prev) URL.revokeObjectURL(prev);
      return "";
    });
  };

  return (
    <>
      <Modal
        title={
          <div style={{ marginBottom: "2rem" }}>Proforma Invoice Filters</div>
        }
        open={isOpen}
        onCancel={handleClose}
        width={600}
        footer={[
          <Button
            key="pdf"
            type="primary"
            onClick={handleGeneratePDF}
            style={{ marginRight: "8px" }}
          >
            <BsDownload style={{ marginRight: "8px" }} /> PDF
          </Button>,
          <Button key="preview" type="primary" onClick={handlePreview}>
            <BsEye style={{ marginRight: "8px" }} /> Preview
          </Button>,
        ]}
      >
        <div>
          <Checkbox
            checked={showLogo}
            onChange={(e) => setShowLogo(e.target.checked)}
            style={{ marginBottom: "10px" }}
          >
            Show logo
          </Checkbox>
        </div>
        <div>
          <Checkbox
            checked={showPeriod}
            onChange={(e) => setShowPeriod(e.target.checked)}
            style={{ marginBottom: "10px" }}
          >
            Show period
          </Checkbox>
        </div>
        <div>
          <Checkbox
            checked={showRatePerMonth}
            onChange={(e) => setShowRatePerMonth(e.target.checked)}
            style={{ marginBottom: "10px" }}
          >
            Show Rate/Month
          </Checkbox>
        </div>
        <div>
          <Checkbox
            checked={showZeroAmountInventories}
            onChange={(e) => setShowZeroAmountInventories(e.target.checked)}
            style={{ marginBottom: "10px" }}
          >
            Show zero amount inventories
          </Checkbox>
        </div>
        <div>
          <Checkbox
            checked={showItemAmount}
            onChange={(e) => setShowItemAmount(e.target.checked)}
            style={{ marginBottom: "10px" }}
          >
            Show total billing amount only
          </Checkbox>
        </div>
        <div>
          <Checkbox
            checked={showSeparateProductionCharges}
            onChange={(e) => setShowSeparateProductionCharges(e.target.checked)}
            style={{ marginBottom: "10px" }}
          >
            Show printing and mounting separately
          </Checkbox>
        </div>
        <div>
          <Checkbox
            checked={showHoardingWisePrintingMounting}
            onChange={(e) =>
              setShowHoardingWisePrintingMounting(e.target.checked)
            }
            style={{ marginBottom: "10px" }}
          >
            Show hoarding wise printing & mounting
          </Checkbox>
        </div>
        <div>
          <Checkbox
            checked={showPrintingMountingOnly}
            onChange={(e) =>
              setShowPrintingMountingOnly(e.target.checked)
            }
            style={{ marginBottom: "10px" }}
          >
            Show printing & mounting only
          </Checkbox>
        </div>
      </Modal>

      <Modal
        title="Proforma Invoice Preview"
        open={isPreviewOpen}
        onCancel={closePreviewModal}
        footer={null}
        width="fit-content"
        centered
      >
        {isPreviewOpen && (
          <iframe
            ref={pdfPreviewRef}
            title="Proforma invoice PDF preview"
            style={{
              width: "310mm",
              height: "197mm",
              border: "none",
              margin: "0 auto",
              display: "block",
              boxShadow: "0 0 15px rgba(0, 0, 0, 0.1)",
            }}
          />
        )}
      </Modal>
    </>
  );
};

export default GeneratePerformanceInvoicePDF;
